import { useMemo } from 'react';
import type { StepListProps } from './components/steps/StepList';
import { SelectEquipment, SelectISP, SelectPremiums, Summary, VerificationAndContactInfo } from './steps/Steps';
import { useBasket } from './useBasket';

export const campaignRoutes = {
  index: '/',
  campaign: ':campaignUrl',
  absoluteStepPathBase: '/:campaignUrl',
  // relative step paths
  campaignPremiums: '',
  campaignEquipment: 'utstyr',
  campaignInternet: 'internett',
  campaignContactInfo: 'kontaktinfo',
  campaignSummary: 'oppsummering',
} as const;

type CampaignRoute = StepListProps[number] & { element: React.ReactNode; type: StepType; wideLayout: boolean };
export type StepType = 'premium' | 'equipment' | 'internet' | 'contactInfo' | 'summary';
const FlowSteps: CampaignRoute[] = [
  { stepPath: campaignRoutes.campaignPremiums, title: 'Innhold', element: <SelectPremiums />, type: 'premium', wideLayout: true },
  { stepPath: campaignRoutes.campaignEquipment, title: 'Utstyr', element: <SelectEquipment />, type: 'equipment', wideLayout: true },
  { stepPath: campaignRoutes.campaignInternet, title: 'Internett', element: <SelectISP />, type: 'internet', wideLayout: false },
  {
    stepPath: campaignRoutes.campaignContactInfo,
    title: 'Din info',
    element: <VerificationAndContactInfo />,
    type: 'contactInfo',
    wideLayout: false,
  },
  { stepPath: campaignRoutes.campaignSummary, title: 'Oversikt', element: <Summary />, type: 'summary', wideLayout: true },
];

export const useFlowSteps = () => {
  const isInternetFlow = useBasket((s) => s.hasInternetProduct)();
  return useMemo(() => {
    if (isInternetFlow) {
      return FlowSteps.filter((step) => step.type !== 'internet');
    }
    return FlowSteps;
  }, [isInternetFlow]);
};
